import "./Loading.css";

export const Loading = () => {
  return <section className="loading">{/* <p>Loading...</p> */}</section>;
};
